<div >
  <form class="flex flex-col gap-4" [formGroup]="addressForm">
    <!-- SECCIÓN 1: Información de Dirección -->
    <app-form-section
      title="Información de Dirección"
      icon="location_on"
      iconColor="blue">
      <div class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Nombre de Dirección -->
          <mat-form-field  class="w-full">
            <mat-label>Nombre de Dirección</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Ej: Oficina Principal"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="addressForm.get('name')?.hasError('required')">
              Campo obligatorio
            </mat-error>
          </mat-form-field>

          <!-- Referencia -->
          <mat-form-field  class="w-full">
            <mat-label>Referencia</mat-label>
            <input
              matInput
              formControlName="reference"
              placeholder="Ej: Frente al parque central"
            />
          </mat-form-field>
        </div>

        <!-- Dirección completa -->
        <mat-form-field  class="w-full">
          <mat-label>Dirección</mat-label>
          <textarea
            matInput
            formControlName="address"
            rows="3"
            placeholder="Ingrese la dirección completa"
            class="resize-none"
            [errorStateMatcher]="errorStateMatcher"
          ></textarea>
          <mat-error *ngIf="addressForm.get('address')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>
      </div>
    </app-form-section>

    <!-- SECCIÓN 2: Ubicación Geográfica -->
    <app-form-section
      title="Ubicación Geográfica"
      icon="public"
      iconColor="green">
      <div class="space-y-4">
        <!-- Coordenadas Geográficas -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <mat-form-field  class="w-full">
            <mat-label>Latitud</mat-label>
            <input
              matInput
              type="text"
              formControlName="latitude"
              (input)="validateDecimal(addressForm.get('latitude').value, 'latitude')"
              placeholder="Ej: 8.22223233"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="addressForm.get('latitude')?.hasError('invalidFormat')">
              Formato inválido. Use punto (.) como separador decimal y solo números.
            </mat-error>
            <mat-error *ngIf="addressForm.get('latitude')?.hasError('invalidRange')">
              La latitud debe estar entre -90 y 90.
            </mat-error>
            <mat-error *ngIf="latitudError && latitudeErrorMessage">
              {{ latitudeErrorMessage }}
            </mat-error>
            <mat-hint>Latitud entre -90 y 90</mat-hint>
          </mat-form-field>

          <mat-form-field  class="w-full">
            <mat-label>Longitud</mat-label>
            <input
              matInput
              type="text"
              formControlName="longitude"
              (input)="validateDecimal(addressForm.get('longitude').value, 'longitude')"
              placeholder="Ej: -123.20323023"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="addressForm.get('longitude')?.hasError('invalidFormat')">
              Formato inválido. Use punto (.) como separador decimal y solo números.
            </mat-error>
            <mat-error *ngIf="addressForm.get('longitude')?.hasError('invalidRange')">
              La longitud debe estar entre -180 y 180.
            </mat-error>
            <mat-error *ngIf="longitudError && longitudeErrorMessage">
              {{ longitudeErrorMessage }}
            </mat-error>
            <mat-hint>Longitud entre -180 y 180</mat-hint>
          </mat-form-field>
        </div>

        <!-- Ubicación: País, Departamento, Ciudad -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <!-- País (mat-autocomplete) -->
          <mat-form-field  class="w-full">
            <mat-label>País</mat-label>
            <input
              type="text"
              matInput
              [formControl]="locationOneCtrl"
              [matAutocomplete]="autoLocationOne"
              placeholder="Buscar país..."
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
              #autoLocationOne="matAutocomplete"
              [displayWith]="fetchLocationOneName"
              (optionSelected)="onLocationOneSelected($event)"
            >
              <mat-option
                *ngFor="let location of filteredLocationOne | async"
                [value]="location._id.toString()"
              >
                {{ location.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="locationOneCtrl.hasError('required')">
              Campo obligatorio
            </mat-error>
            <mat-error *ngIf="locationOneCtrl.hasError('invalidSelection')">
              Debe seleccionar una opción de la lista
            </mat-error>
          </mat-form-field>

          <!-- Departamento (mat-autocomplete) -->
          <mat-form-field  class="w-full">
            <mat-label>Departamento</mat-label>
            <input
              type="text"
              matInput
              [formControl]="locationTwoCtrl"
              [matAutocomplete]="autoLocationTwo"
              [disabled]="!getSelectedLocationOne()"
              placeholder="Buscar departamento..."
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
              #autoLocationTwo="matAutocomplete"
              [displayWith]="fetchLocationTwoName"
              (optionSelected)="onLocationTwoSelected($event)"
            >
              <mat-option
                *ngFor="let location of filteredLocationTwo | async"
                [value]="location._id.toString()"
              >
                {{ location.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="locationTwoCtrl.hasError('invalidSelection')">
              Debe seleccionar una opción de la lista
            </mat-error>
          </mat-form-field>

          <!-- Ciudad (mat-autocomplete) -->
          <mat-form-field  class="w-full">
            <mat-label>Ciudad</mat-label>
            <input
              type="text"
              matInput
              [formControl]="locationThreeCtrl"
              [matAutocomplete]="autoLocationThree"
              [disabled]="!getSelectedLocationTwo()"
              placeholder="Buscar ciudad..."
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
              #autoLocationThree="matAutocomplete"
              [displayWith]="fetchLocationThreeName"
              (optionSelected)="onLocationThreeSelected($event)"
            >
              <mat-option
                *ngFor="let location of filteredLocationThree | async"
                [value]="location._id.toString()"
              >
                {{ location.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="locationThreeCtrl.hasError('invalidSelection')">
              Debe seleccionar una opción de la lista
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Código Postal -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <mat-form-field  class="w-full">
            <mat-label>Código Postal</mat-label>
            <input
              matInput
              formControlName="postalCode"
              placeholder="Ej: 11101"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="addressForm.get('postalCode')?.hasError('required')">
              Campo obligatorio
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </app-form-section>

    <!-- SECCIÓN 3: Información de Contacto -->
    <app-form-section
      title="Información de Contacto"
      icon="person"
      iconColor="purple">
      <div class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Tipo de Dirección (mat-autocomplete) -->
          <mat-form-field  class="w-full">
            <mat-label>Tipo de Dirección</mat-label>
            <input
              type="text"
              matInput
              [formControl]="addressTypeCtrl"
              [matAutocomplete]="autoAddressType"
              placeholder="Buscar tipo..."
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-autocomplete
              #autoAddressType="matAutocomplete"
              [displayWith]="fetchAddressTypeName"
              (optionSelected)="onAddressTypeSelected($event)"
            >
              <mat-option
                *ngFor="let type of filteredAddressTypes | async"
                [value]="type._id.toString()"
              >
                <span>
                  {{ type.name }}
                  <span
                    *ngIf="type.isDelivery === true"
                    class="ml-2 px-2 py-0.5 rounded bg-blue-600 text-white text-xs"
                  >
                    ENTREGA
                  </span>
                </span>
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="addressTypeCtrl.hasError('required')">
              Campo obligatorio
            </mat-error>
            <mat-error *ngIf="addressTypeCtrl.hasError('invalidSelection')">
              Debe seleccionar una opción de la lista
            </mat-error>
          </mat-form-field>

          <!-- Nombre del Contacto -->
          <mat-form-field  class="w-full">
            <mat-label>Nombre del Contacto</mat-label>
            <input
              matInput
              formControlName="contactName"
              placeholder="Ej: Juan Pérez"
              [errorStateMatcher]="errorStateMatcher"
            />
            <mat-error *ngIf="addressForm.get('contactName')?.hasError('required')">
              Campo obligatorio
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </app-form-section>
  </form>
</div>
